// audit-trail.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuditTrailService {
  private apiUrl = 'http://localhost:3000/audit-logs'; // Update with your API URL

  constructor(private http: HttpClient) {}

  logEvent(auditData: AuditData) {
    return this.http.post(`${this.apiUrl}/log`, auditData).subscribe(
      response => console.log('Audit log saved', response),
      error => console.error('Audit log failed', error)
    );
  }

  getAuditTrail(documentId: string) {
    return this.http.get<AuditData[]>(`${this.apiUrl}/document/${documentId}`);
  }
}

export interface AuditData {
timestamp: string|number|Date;
  userId: string;
  userName: string;
  action: string;
  documentId?: string;
  documentName?: string;
  ipAddress?: string;
  details?: any;
}
